import { For, JSX, createEffect, createSignal } from "solid-js";
import { useDateWidget } from "../../../providers/dates/context";
import { EventCard } from "../EventCard";
import { DateEvent } from "../../../types/date";
import dayjs from "dayjs";
import { Text } from "~/components/ui/text";
import { Group } from "~/components/ui/group";
import { Badge } from "~/components/ui/badge";
import { Icon } from "~/components/ui/icon";
import { mdiCalendarMultiple } from "@mdi/js";

export function EventList(props: JSX.HTMLAttributes<HTMLDivElement>) {

	const { events, oncomingEvents, state, setListRef, listRef } = useDateWidget();
	const [group, setGroup] = createSignal<[number, DateEvent[]][]>([]);

	createEffect(() => {

		const _events = events();

		const group = _events.reduce((acc, event) => {
			const key = event.startTime.getFullYear();
			const group = acc.get(key) || [];

			group.push(event);

			acc.set(
				key,
				group.sort((a, b) => a.startTime.getTime() - b.startTime.getTime())
			);

			return acc;
		}, new Map<number, DateEvent[]>());

		setGroup(Array.from(group));
	});

	createEffect(() => {

		const ref = listRef();

		if (!ref) {
			return;
		}

		// when state is equals to idle, scroll to the current date
		if (state() === "loading") {
			const events = oncomingEvents();

			if (!events.length) {
				return;
			}

			setTimeout(() => {
				// Scroll to the first event
				const firstEvent = events[0];
				const date = dayjs(firstEvent.startTime).format("YYYY-MM-DD");
				const element = ref.querySelector(`[data-date="${date}"]`) as HTMLElement;

				if (!element) {
					return;
				}

				ref.scrollTop = element.offsetTop - ref.offsetTop - 20;
			}, 0);
		}
	});

	return (
		<div
			ref={setListRef}
			{...props}
		>
			<For each={group()}>
				{([year, events]) => (
					<>
						<Group justify="between">
							<Text>{year}</Text>
							<Badge class="rounded-full px-3">
								{events.length}
								<Icon class="size-3 ml-1.5" path={mdiCalendarMultiple} />
							</Badge>
						</Group>
						<For each={events}>
							{event => <EventCard event={event} enableTime />}
						</For>
					</>
				)}
			</For>
		</div>
	);
}